import { defineComponent } from "bitecs";
import { Vector3 } from "./Vector3";

export const PositionComponent = defineComponent(Vector3);
